import { thunk } from 'easy-peasy';

export default {
	sendRequest: thunk((actions, payload, { getStoreState, injections, getStoreActions }) => {
		const { services } = injections;
		return services.notifications.markAsRead(payload).catch(e => console.log(e));
	})
};
